import qs from 'qs'

import { ContactBalance, ContactBalanceQueryProps } from '@features/contactBalance'

import { getRequest } from '../../utils'

export interface FetchDebtorsResponseData {
  data: ContactBalance[]
}

export const fetchDebtors = ({
  acceptLanguage,
  date,
  exportType = 'json',
  organizationId,
  page,
  pageSize,
  searchQuery,
  sortProperty,
  sortDirection,
}: ContactBalanceQueryProps): Promise<FetchDebtorsResponseData> => {
  const queryParams = qs.stringify({
    acceptLanguage,
    ...(date ? { date } : {}),
    ...(page ? { page } : {}),
    ...(pageSize ? { pageSize } : {}),
    ...(searchQuery ? { search: searchQuery } : {}),
    ...(sortProperty ? { sortBy: sortProperty } : {}),
    ...(sortDirection ? { sortDirection } : {}),
  })

  return getRequest(`/v2/organizations/${organizationId}/debtorList.${exportType}?${queryParams}`)
}
